// authReducer.js
import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT } from './actionTypes';

const initialState = {
  userData: null,
  error: null,
  isLoggedIn: false,
  token: null,  
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload.userData.user,
        token: action.payload.userData.user.token,
        isLoggedIn: true
      };
    case LOGIN_FAILURE:
      return { ...state, userData: null, error: action.payload, isLoggedIn: false, token: null };
    case LOGOUT:
      return { ...initialState, isLoggedIn: false, token: null };
    default:
      return state;
  }
};

export default authReducer;
